import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Stack } from "@mui/material"

export function OriginalContent() {
    const { normalChildren } = useBoundContext()
    return <Stack alignItems="stretch">{normalChildren}</Stack>
}
